import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';
import * as moment from 'moment';

//conv dd/mm/yyyy to timestamp

export function dobValidatorTraveller(control: FormControl) {
    let date = control.value;
    //let day, month, year;
    if (date) {

        var dateMoment = moment(date, "DD-MM-YYYY");
        var yesterdayMoment = moment().subtract(1, 'days');
        var todayMoment = moment();

        // abhinav's date validator
        // [day, month, year] = dob.split('/').map(e => parseInt(e));

        // if (day && month && year) {
        //     //check if 18y old
        //     var today = new Date();
        //     var age = today.getFullYear() - year;
        //     if (today.getMonth() < month || (today.getMonth() == month && today.getDate() < day)) {
        //         age--;
        //     }
        //     if (age < 18) {
        //         return {
        //             minor: true
        //         }
        //     }



        // }

        if (dateMoment.isValid()) {

            if (todayMoment.diff(dateMoment, 'years', true) > 69) {
                return {
                    major: true
                }
            }
            // else if (todayMoment.diff(dateMoment, 'years', true) > 100) {

            //     return {
            //         major: true
            //     }
            // }

        }

        if (!dateMoment.isValid()) {

            return {
                invalid: true
            }
        }
    }


    return null;
}

@Directive({
    selector: '[dobValidatorTraveller][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useValue: dobValidatorTraveller,
            multi: true
        }
    ]
})
export class DobValidatorTraveller {
}